import { TranslocoConfig, translocoConfig } from '@jsverse/transloco';
import { DEFAULT_LANGUAGE, SUPPORTED_LANGUAGES } from '@jfw/types';

/**EXT-5707: platform-portal's Transloco config, shared by `app.config.ts` and
 * the spec that checks its missing-translation behavior.
 *
 * A key with no Spanish (or an empty Spanish value) shows its English text
 * (`fallbackLang` + `useFallbackTranslation`); a key missing from every
 * language shows the key itself. Never a blank.
 */
export function platformPortalTranslocoConfig(
  prodMode: boolean,
): TranslocoConfig {
  // translocoConfig() fills in Transloco's defaults for everything not set
  // here (e.g. missingHandler.allowEmpty: false, so '' counts as missing).
  return translocoConfig({
    availableLangs: [...SUPPORTED_LANGUAGES],
    defaultLang: DEFAULT_LANGUAGE,
    fallbackLang: DEFAULT_LANGUAGE,
    missingHandler: { useFallbackTranslation: true },
    reRenderOnLangChange: true,
    prodMode,
  });
}
